// extracted by mini-css-extract-plugin
export default {"root":"Show_root__FcpXM","arrowWrapper":"Show_arrowWrapper__X6ajC","description":"Show_description__O+HS0"};